const fetchPricePerfullSharesHistoryData = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API}/ppfs/get`)
    const result = await response.json()
    if (result.status === 'success') {
      return result.data
    }
    return []
  } catch (error) {
    console.error(error)
    return []
  }
}

export default fetchPricePerfullSharesHistoryData
